import React, { useState } from 'react';
import {
    PopupContainer,
    PopupContent,
    PopupTitle,
    Title,
    Icon,
    Merge,
    PopUpImage,
    BackTitle
} from './Popup.styled';
import Close from '../../../assets/images/CloseProduct.svg';
import {
    updateNavBarPosition,
    updateContainerPosition,
    isMobileView,
    isMobileDevice,
    isLandscape,
    logErrorToConsole,
} from '../../../utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const Popup = ({
        children,
        borderRadius = '12px',
        title = '',
        onClose = null,
        img = '',
        onClick = () => {},
        width = '100%',
        webWidth = '',
        webHeight = '',
        fontSize = '',
        hideIcon = false,
        margin = '',
        zIndex,
        isUnsavedPage = false,
        overflow = '',
        textAlign = '',
        lineHeight = '',
        DeskFontSize = '',
        addProductSpecific = false,
        mobileWidth = false,
        imageMarginLeftDesktop = '',
        imageMarginLeftMobile = '',
        opacity = 1,
        imgRightToText = '',
        imgRightToTextMarginLeft = '',
        popupContentPadding = '15px 20px',
        popupContentPaddingMobile = '',
        mobileWidthPercent = '',
        impersonationBackground = '',
        SignatureMargin = '',
        popHeight = '',
        contentTabHeight = '',
        contentWidth = '',
        shipAdressPopup = '',
        borderTopRightRadius = '',
        borderTopLeftRadius = '',
        id,
        mobileMargin = '',
        minHeight = '',
        iconWidth = '22px',
        mobileZIndex = '',
        position = '',
        top = '',
        isDelayPositionChange = false,
        fromMore = false,
        alignItemsMob = 'center',
        color = '',
        mobileBg = '',
        mbOverflowY = '',
        mobHeight = '',
        smalHeight = '',
        landscapeMarginTop= '',
        landscapeMarginBottom= '',
        landscapeHeight= '',
        mbLandscapeHeight='',
        colortitle = '',
        backgroundColor = '',
        mbBackGround = '',
        emptyCartWidth = '',
        ipadwidth = '',
        portraitWidth = '',
        mobileWidthB33Popup = '',
        titleWidth = '',
        flexDirection = '',
        imgLeftToText = '',
        titleFontWeight = '',
        titleFontFamily = '',
        isFromPop = false,
        mbJustifyContent = '',
        mbMarginRight = '',
        LeftArrow = '',
        backToText = '',
        isEquityCart = false,
        isSurgeryCart = false,
        mbIconMarginRight='',
        isEmptyCart=false,
        isFromBundle = false,
    contentHeight = ' ',
    allowLandscapeScroll = true,
    mbPaddingTop,
    }) => {
          const [hasBanner, setHasBanner] = useState(false);
    const [isInLandscapeMode, setIsInLandscapeMode] = useState(false);
    const updateUsageFixedPosition = () => {
        isMobileView() && updateContainerPosition('#UsageContainer', 'fixed');
    };

    useEffectWithErrorLogging(() => {
        const checkBanner = () => {
            const bannerElement = document.querySelector('.banner-container');
            setHasBanner(!!bannerElement);
        };

        checkBanner();

        const observer = new MutationObserver(checkBanner);
        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, []);

    useEffectWithErrorLogging(() => {
        const checkOrientation = () => {
            const isMobile = isMobileDevice();
            const isInLandscape = isLandscape();
            setIsInLandscapeMode(isMobile && isInLandscape);
        };

        checkOrientation();

        window.addEventListener('resize', checkOrientation);
        window.addEventListener('orientationchange', checkOrientation);

        if (window.screen?.orientation) {
            window.screen.orientation.addEventListener(
                'change',
                checkOrientation
            );
        }

        return () => {
            window.removeEventListener('resize', checkOrientation);
            window.removeEventListener('orientationchange', checkOrientation);
            if (window.screen?.orientation) {
                window.screen.orientation.removeEventListener(
                    'change',
                    checkOrientation
                );
            }
        };
    }, []);

    useEffectWithErrorLogging(() => {
        updateNavBarPosition('absolute');
        updateContainerPosition('#UsageContainer', 'unset');
        if (!fromMore) {
            return () => {
                updateNavBarPosition('fixed');
                if (isDelayPositionChange) {
                    setTimeout(() => {
                        try {
                        updateUsageFixedPosition();
                        }
                        catch (error) {
                            logErrorToConsole(error);
                        }
                    }, [1000]);
                } else {
                    updateUsageFixedPosition();
                }
            };
        }
    }, []);

    const renderBackButton = () => (
        LeftArrow && (
            <BackTitle fontSize="14px" onClick={onClick} data-testid="popup-back">
                <img src={LeftArrow} alt="back"/>
                {`${backToText} `}
            </BackTitle>
        )
    );

    const renderImage = (imageSrc, marginLeftDesktop, marginLeftMobile) => (
        <PopUpImage
            marginLeftDesktop={marginLeftDesktop}
            marginLeftMobile={marginLeftMobile}
            img={imageSrc}
            data-testid="popup-image"
        />
    );

    const getDynamicMarginTop = () => {
        if (hasBanner && isInLandscapeMode) {
            return landscapeMarginTop || '20px';
        }
        return landscapeMarginTop;
    };

    return (
        <>
            <PopupContainer
                overflow={overflow}
                zIndex={zIndex}
                isUnsavedPage={isUnsavedPage}
                opacity={opacity}
                background={impersonationBackground}
                popHeight={popHeight}
                contentTabHeight={contentTabHeight}
                shipAdressPopup={shipAdressPopup}
                mobileZIndex={mobileZIndex}
                mbBackGround={mbBackGround}
                isFromPop={isFromPop}
                hasBanner={hasBanner}
                isLandscape={isInLandscapeMode}
                allowLandscapeScroll={allowLandscapeScroll}
                data-testid="popup-container"
                mbPaddingTop={mbPaddingTop}
            >
                <PopupContent
                    borderRadius={borderRadius}
                    margin={margin}
                    addProductSpecific={addProductSpecific}
                    mobileWidth={mobileWidth}
                    mobileWidthPercent={mobileWidthPercent}
                    popupContentPadding={popupContentPadding}
                    popupContentPaddingMobile={popupContentPaddingMobile}
                    SignatureMargin={SignatureMargin}
                    popHeight={popHeight}
                    isEmptyCart={isEmptyCart}
                    isFromPop={isFromPop}
                    contentWidth={contentWidth}
                    emptyCartWidth={emptyCartWidth}
                    ipadwidth={ipadwidth}
                    portraitWidth={portraitWidth}
                    mobileWidthB33Popup={mobileWidthB33Popup}
                    contentTabHeight={contentTabHeight}
                    shipAdressPopup={shipAdressPopup}
                    borderTopRightRadius={borderTopRightRadius}
                    borderTopLeftRadius={borderTopLeftRadius}
                    mobileMargin={mobileMargin}
                    minHeight={minHeight}
                    mobileBg={mobileBg}
                    mobHeight={mobHeight}
                    mbOverflowY={mbOverflowY}
                    smalHeight={smalHeight}
                    landscapeMarginTop={getDynamicMarginTop()}
                    landscapeMarginBottom={landscapeMarginBottom}
                    landscapeHeight={landscapeHeight}
                    mbLandscapeHeight={mbLandscapeHeight}
                    id={id}
                    position={position}
                    top={top}
                    backgroundColor={backgroundColor}
                    flexDirection={flexDirection}
                    hasBanner={hasBanner}
                    isLandscape={isInLandscapeMode}
                    data-testid="popup-content"
                    contentHeight={contentHeight}
                >
                    {title && (
                        <PopupTitle color={color} fontFamily={titleFontFamily} mbJustifyContent={mbJustifyContent}>
                            {renderBackButton()}
                            <Merge
                                width={isFromBundle ? '' : width}
                                webHeight={webHeight}
                                webWidth={webWidth}
                                alignItemsMob={alignItemsMob}
                                mbMarginRight={mbMarginRight}
                                mbJustifyContent={mbJustifyContent}
                            >
                                {img && renderImage(img, imageMarginLeftDesktop, imageMarginLeftMobile)}
                                {imgLeftToText && renderImage(imgLeftToText, imageMarginLeftDesktop, imgRightToTextMarginLeft)}
                                <Title
                                    fontSize={fontSize}
                                    textAlign={textAlign}
                                    lineHeight={lineHeight}
                                    DeskFontSize={DeskFontSize}
                                    color={colortitle}
                                    width={titleWidth}
                                    fontWeight={titleFontWeight}
                                >
                                    {title}
                                </Title>
                                {imgRightToText && renderImage(imgRightToText, imageMarginLeftDesktop, imgRightToTextMarginLeft)}
                            </Merge>
                            {onClose ? (
                                <Icon
                                    id="popup-close-icon"
                                    data-testid="popup-close"
                                    onClick={onClose}
                                    mobilePath={Close}
                                    mbIconMarginRight={mbIconMarginRight}
                                    iconWidth={iconWidth}
                                    mbIconWidth={isEquityCart || isSurgeryCart
                                            ? '30px' : 'null' 
                                        }
                                    mbIconMarginLeft={isEquityCart || isSurgeryCart 
                                            ? '2%' : 'null'
                                        }
                                />
                            ) : (
                                <Icon
                                id="popup-close-icon"
                                    onClick={onClick}
                                    mbIconMarginRight={mbIconMarginRight}
                                    mobilePath={Close}
                                    hideIcon={hideIcon}            
                                />
                            )}
                        </PopupTitle>
                    )}
                    {children}
                </PopupContent>
            </PopupContainer>
        </>
    );
};

export default Popup;